<script>
    import {getGPTransFunc} from "./gp-translations.js";
    import jQuery from "jquery";
    import {GPContextItems, activePickerItem} from "./gp-context-items";
    import {textFilter, typeFilter} from "./gp-structurepickerstore.js";
    import {customStore} from './gp.js';
    import {tick} from 'svelte';
    import GPStructureItem from "./gp-structurepickeritem.svelte"
    import {flip} from 'svelte/animate';
    import { onMount } from 'svelte';
    import {GPTypeStructure} from "./gp-typestructure";

    let trans = getGPTransFunc("gp-structurepicker");
    let initialItemsLimit = 50;
    let itemsLimit = 50;
    let itemsVisibleCount;
    let overLimitCount;
    let structures = [];
    $: {
        update($textFilter, $typeFilter)
    }

    $: {structures = [...$customStore, ...GP.structureTypes].filter(a => !a.temp); update()}


    let elemsInRow = null;

    onMount(() => {
        jQuery(window).off('resize', onResize);
        jQuery(window).on('resize', onResize);

        var chk_scroll = function (e) {
            var elem = jQuery(e.currentTarget);
            if (elem[0].scrollHeight - elem.scrollTop() - 10 < elem.outerHeight()) loadMore();
        };
        jQuery('#GPStructurePickerList').bind('scroll', chk_scroll);

        if (!$activePickerItem || !($activePickerItem instanceof GPTypeStructure)) selectFirstItem();
        onResize();
    })

    function update() {
        itemsVisibleCount = 0;
        let allFittingCount = 0;

        //sort by structure.type (string)
        structures.sort((a, b) => {
            if (a.type < b.type) return -1;
            if (a.type > b.type) return 1;
            return 0;
        });

        structures = structures.map((el, i) => {
            el.visible = true;

            if (!el.active) el.visible = false;

            let filterMapping = {
                "filterBench": {"ławka": 1},
                "filterFence": {"ogrodzenie": 1},
                "filterHut": {"altana": 1}
            };

            let res = searchAndFormat($textFilter.toLowerCase(), el.name);

            if (!res)
                el.visible = false;
            else
                el.displayName = res;

            if (el.visible && $typeFilter && filterMapping[$typeFilter] && filterMapping[$typeFilter][el.type] !== 1) el.visible = false;
            if (el.visible && $typeFilter && $typeFilter==="filterCustom" && el.type !== "custom") el.visible = false;

            if (el.visible) {
                allFittingCount += 1;
            }
            if (itemsVisibleCount > itemsLimit) el.visible = false;
            if (el.visible) {
                itemsVisibleCount += 1;
            }

            return el;
        });
        overLimitCount = allFittingCount - itemsVisibleCount;
    }

    function loadMore(uptoIdx) {
        if (overLimitCount === 0) return;
        let addAmount = uptoIdx ? uptoIdx : initialItemsLimit;
        itemsLimit += addAmount;
        update();
    }

    function loadUntil(structureId) {
        let idx;
        structures.forEach((el, i) => {
            if (el.id == parseInt(structureId)) idx = i;
        })
        if (idx) loadMore(idx + 1);
    }

    function selectItem(structure) {
        $activePickerItem = structure;
    }

    export async function selectFirstItem() {
        selectItem(structures.filter((e) => e.visible)[0]);
        await tick();
        scrollToSelected();
    }

    function scrollToSelected() {
        setTimeout(async () => {
            await tick();
            if (jQuery(".GPStructurePickerItem").length) { //this additional check is need, because event can fire this function even when component is umoun
                let el = jQuery('.GPStructurePickerItem.selected');
                if (el) {
                    let main = jQuery("#GPStructurePickerList");
                    let top = jQuery(".GPStructurePickerItem").eq(0).parent().position().top;
                    let t = el.position().top;
                    main.animate({scrollTop: -top + t}, 100);
                }
            }
        }, 500)
    }

    function selectNextItem(step) {
        let displayedObjs = structures.filter((e) => e.visible);
        let newActiveIndex = displayedObjs.indexOf($activePickerItem) + step;
        if (newActiveIndex >= displayedObjs.length) newActiveIndex = displayedObjs.length - 1;
        $activePickerItem = displayedObjs[newActiveIndex];
        scrollToSelected();
    }

    function selectPrevItem(step) {
        let displayedObjs = structures.filter((e) => e.visible);
        let newActiveIndex = displayedObjs.indexOf($activePickerItem) - step;
        if (newActiveIndex < 0) newActiveIndex = 0;
        $activePickerItem = displayedObjs[newActiveIndex];
        scrollToSelected();
    }

    function handleKeyboard(e) {
        if (!$activePickerItem || !(jQuery(".GPPickerArea.active").length)) return;
        switch (e.which) {
            case 37: // left
                selectPrevItem(1);
                break;

            case 38: // up
                selectPrevItem(elemsInRow);
                break;

            case 39: // right
                selectNextItem(1);
                break;

            case 40: // down
                selectNextItem(elemsInRow);
                break;

            case 32: // space
                GPContextItems.addItemAtDefaultPos();
                break;

            case 191: // ?
                GP.showDetailsOfItem($activePickerItem);
                break;

            default:
                return; // exit this handler for other keys
        }
        e.preventDefault(); // prevent the default action (scroll / move caret)
    }

    function searchAndFormat(pattern, cand) {
        var pos;
        pos = cand.toLowerCase().indexOf(pattern);
        if (pos >= 0) {
            return cand.substr(0, pos) + '<b>' + cand.substr(pos, pattern.length) + '</b>' + cand.substr(pos + pattern.length);
        }
        return false;
    }

    async function resetPicker() {
        $typeFilter = "filterAll";
        $textFilter = "";
        await tick();
        selectFirstItem();
    }


    export async function findAndSelect(itemInstance) {
        $typeFilter = "filterAll";
        $textFilter = "";
        await tick();
        $activePickerItem = itemInstance.data;

        loadUntil($activePickerItem.id);
        await tick();
        scrollToSelected();
    }

    export function onResize() {
        var pickerW = jQuery('.GPPickerArea').innerWidth();
        elemsInRow = Math.floor(pickerW / 110);
        jQuery('#GPStructurePickerList').css('grid-template-columns', 'repeat(' + elemsInRow + ', 1fr)');
    }

</script>

<svelte:window on:keydown={handleKeyboard} on:GPNewProject={resetPicker}/>

    <li on:click={()=>GPSettings.storageClass.ensureLogged(GP.GPUploadCustomObject)} class="list-group-item GPCustomObjectPickerAddItem enabled">
        <i class="fa fa-plus-circle fa-2x"></i>
    </li>
{#each structures.filter(el => el.visible) as structure (structure)}
    <li  animate:flip={{duration: 200}}>
        <GPStructureItem structure={structure}/>
    </li>
{/each}

{#if overLimitCount > 0}
    <li class="list-group-item GPStructurePickerItem " on:click={loadMore}>
        <div class="GPStructurePickerMoreAvailable">
            + {overLimitCount} {trans( "more")}<br/>
            {trans( "click to load more or use filters")}
        </div>
    </li>
{/if}

{#if itemsVisibleCount === 0}
    <li class="list-group-item GPStructurePickerItem ">
        <div class="GPStructurePickerEmptyResult">
            {trans( "No items matching")}. <a
                on:click={resetPicker}
                class="clearFilters">{trans( "Clear filters")}</a>
        </div>
    </li>
{/if}
